<template>
  <div class="d-flex align-items-center justify-content-center h-400" v-if="loading">
    <span class="spinner-border"></span>
  </div>
  <div class="change-profile-wrapper" v-else>

    <a href="https://support.livingdna.com/hc/en-us" target="_blank">
      <div class="profile-row-wrapper mt-0 rounded-4 p-3">
        <div>
          <div class="profile-flex-row d-flex">
            <div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-help-circle vue-feather__content">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg></div>
            <div class="overflow-hidden">
              <p class="font-semibold text-grey-600" title="Support">Support</p>
              <p class="d-flex align-items-center m-0">
                <span class="text-grey-600 text-base" title=" Find answers in our support centre "> Find answers in our
                  support centre </span>
              </p>
            </div>
          </div><!-- flex row -->
        </div>
      </div>
    </a>


    <a href="https://livingdna.com/uk/legal/Terms-Of-Use" target="_blank">
      <div class="profile-row-wrapper mt-0 rounded-4 p-3">
        <div>
          <div class="profile-flex-row d-flex">
            <div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-file-text vue-feather__content">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>


            </div>
            <div class="overflow-hidden">
              <p class="font-semibold text-grey-600" title="Terms and conditions">Terms and conditions</p>
              <p class="d-flex align-items-center m-0">
                <span class="text-grey-600 text-base" title=" See our terms and conditions "> See our terms and
                  conditions </span>
              </p>
            </div>
          </div><!-- flex row -->
        </div>
      </div>
    </a>

    <a href="https://livingdna.com/uk/privacy-centre" target="_blank">
      <div class="profile-row-wrapper mt-0 rounded-4 p-3">
        <div>
          <div class="profile-flex-row d-flex">
            <div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-lock vue-feather__content">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>


            </div>
            <div class="overflow-hidden">
              <p class="font-semibold text-grey-600" title="Privacy policy">Privacy policy</p>
              <p class="d-flex align-items-center m-0">
                <span class="text-grey-600 text-base" title=" Learn how we store your data securely  "> Learn how we
                  store your data securely </span>
              </p>
            </div>
          </div><!-- flex row -->
        </div>
      </div>
    </a>


    <button class="btn btn-primary w-50" @click="gotoPage('profiles')" style='display:none'>
      Upload DNA
    </button>

  </div>
</template>

<script setup>
import ProfileService from "@/services/profile";
import store from "@/store";
import { isEmpty } from "lodash";

import { ref, reactive, onMounted, computed, defineEmits } from "vue";
import { useRouter } from "vue-router";

const emits = defineEmits(["close"]);

const accountTests = computed(() => store.getters.accountTests);
const allProfiles = reactive({});
const mergedTestAndProfile = ref([]);
const loading = ref(false);

onMounted(async () => {
  try {
    loading.value = true;

    const allUserProfiles = await ProfileService.getProfiles();
    Object.assign(allProfiles, allUserProfiles);

    if (isEmpty(accountTests.value)) {
      await store.dispatch("SET_ACCOUNT_TESTS");
    }

    mergedTestAndProfile.value = accountTests.value.map((test) => ({
      ...allProfiles[test.barcode],
      ...test,
    }));

  } catch (err) {
    console.error("Error occurred", err);
  } finally {
    loading.value = false;
  }
});

const router = useRouter();


const gotoPage = (name) => {
  emits("close");
  router.push({ name });
};

</script>

<style lang="scss">
.add-profile-card {
  height: 64px;
  background: rgba(235, 242, 255, 1);
  border: 1px rgba(51, 119, 255, 1);
  box-shadow: 0px 4px 20px 0px rgba(238, 238, 238, 0.502);
  border-radius: 14px;
  border-style: dashed;
  display: flex;
  padding: 10px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    border-style: solid;
  }
}

.add-profile-card div {
  display: flex;
  gap: 8px;
  height: 24px;
  font-size: 14px;
  color: rgba(51, 119, 255, 1);
  align-items: center;
}

.change-profile-wrapper {
  margin-top: -15px;
  a{
    text-decoration: none;
  }
}

.change-profile-scroll {
  max-height: calc(100dvh - 200px);
  scrollbar-width: thin;
  padding-right: 5px;
}

.change-profile-wrapper>p {
  color: #1b1b1b;
  font-weight: 400;
  font-size: 16px;
}

.profile-row-wrapper.mt-0.rounded-4.p-3 {
  margin-bottom: 10px;
}

.profile-row-wrapper {
  border: 1px solid #d0d0d0;
  padding: 20px 20px;
  border-radius: 20px;
  margin: 15px 0px;
  display: grid;
  grid-template-columns: 4fr 0.6fr;
  gap: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}

.profile-row-wrapper>div {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.profile-flex-row {
  display: grid !important;
  grid-template-columns: auto 1fr 190px;
  gap: 20px;
  align-items: center;

  >div>img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
}

.profile-flex-row>div:nth-child(2)>p:nth-child(3) {
  margin-bottom: 0rem;
}

.profile-flex-row>div:nth-child(2)>p:nth-child(1) {
  color: #1b1b1b;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: -0.2rem;
}

.profile-flex-row>div:nth-child(2)>p:nth-child(2) {
  color: #00000099;
  font-weight: 500;
  font-size: 13px;
  margin-bottom: 0.1rem;
}

.profile-flex-row>div:nth-child(2)>p:nth-child(3) {
  color: #b6b6b6;
  font-weight: 500;
  font-size: 12px;
}

.form__radio-input {
  display: none;
}

.form__radio-label {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 1rem;
  font-size: 1.5rem;
  cursor: pointer;
}

.form__radio-button {
  height: 2rem;
  width: 2rem;
  border: 5px solid #d9d9d9;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  transform: translateY(-2px);
}

.form__radio-button::after {
  content: "";
  display: block;
  height: 1rem;
  width: 1rem;
  position: absolute;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transition: opacity 0.1s;
  transform: translate(-50%, -50%);
  background-color: #3377ff;
  opacity: 0;
}

.selected-profile {
  border-color: #3377ff;
  /* Change border color when selected */
}

.form__radio-input:checked+.form__radio-label .form__radio-button::after {
  opacity: 1;
}

@media screen and (min-width: 599px) {
  .truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .overflow-hidden {
    overflow: hidden;
  }
}

@media screen and (max-width: 598px) {
  .profile-flex-row {
    flex-direction: column !important;
    display: flex !important;
  }
  .profile-row-wrapper{
    flex-direction: column !important;
    display: flex !important;
    text-align: center;
  }
  // Each selector names the class: written as "div p, ul, span" the ul and span parts matched
  // every list and span on the site, centring them on phones
  .add-manager-profile-details div p,
  .add-manager-profile-details ul,
  .add-manager-profile-details span {
    text-align: center;
  }

  .profile-flex-row>div:nth-child(3) {
    margin-right: auto !important;
    margin-left: initial !important;
  }

  .profile-flex-row>div:nth-child(2)>p:nth-child(2) {
    line-height: 1.2;
    padding-top: 4px;
  }

  .form__radio-button {
    height: 1.5rem;
    width: 1.5rem;

    &::after {
      height: .6rem;
      width: .6rem;
    }
  }

  .profile-flex-row>div>img {
    width: 40px;
    height: 40px;
  }

  .truncate {
    text-align: left;
  }
}
</style>
